import Quill from 'quill/core';
import React from 'react';
import type { TetherPortalContainer } from '../../../components/Tether';
import { useQuillSelection, useQuillState } from '../../QuillContext';
import type QuillEditor from '../../QuillEditor';
import LinkToolbar from './LinkToolbar';
import ToolbarPopOver from './ToolbarPopOver';

interface LinkOnlyEditorToolbarProps {
  quill: QuillEditor;
  portalContainer?: TetherPortalContainer;
}

const LinkOnlyEditorToolbar = ({
  quill,
  portalContainer,
}: LinkOnlyEditorToolbarProps) => {
  const { isEditingLink } = useQuillState();
  const { range, formats } = useQuillSelection();

  return (
    <ToolbarPopOver portalContainer={portalContainer}>
      {() =>
        isEditingLink ||
        (formats.link &&
          // Don't show toolbar when the cursor is at beginning to avoid
          // auto focusing brings out the toolbar.
          !(range?.length === 0 && range.index === 0)) ? (
          <LinkToolbar
            quill={quill}
            onLinkChange={(value) =>
              quill.format('link', value, Quill.sources.USER)
            }
          />
        ) : null
      }
    </ToolbarPopOver>
  );
};

export default LinkOnlyEditorToolbar;
